<template>
  <!-- 勘察设计 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="编号">
              <a-input v-model="query.establishmentNo"
                       placeholder="请输入项目编号"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="项目名称">
              <a-input v-model="query.establishmentName"
                       placeholder="请输入项目名称"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="计划开始时间">
              <a-date-picker v-model="query.planStartTime"
                             show-time
                             format="YYYY-MM-DD HH:mm:ss"
                             valueFormat="YYYY-MM-DD HH:mm:ss"
                             placeholder="选择计划开始时间"
                             @change="onChange"
                             @ok="onOk"
                             style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="计划结束时间">
              <a-date-picker format="YYYY-MM-DD HH:mm:ss"
                             valueFormat="YYYY-MM-DD HH:mm:ss"
                             v-model="query.planEndTime"
                             show-time
                             placeholder="选择计划结束时间"
                             @change="onChange"
                             @ok="onOk"
                             style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="勘察状态">
              <a-select style="width: 100%"
                        v-model="query.reconnaissanceStatus"
                        placeholder="请选择勘察状态">
                <a-select-option :value="0"> 未开始 </a-select-option>
                <a-select-option :value="1"> 勘测进行中 </a-select-option>
                <a-select-option :value="2"> 勘测完成 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="创建时间">
              <a-date-picker v-model="query.endTime"
                             format="YYYY-MM-DD"
                             valueFormat="YYYY-MM-DD"
                             placeholder="请选择创建时间"
                             @change="onChange"
                             @ok="onOk"
                             style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="审核状态">
              <a-select style="width: 100%"
                        v-model="query.approveStatus"
                        placeholder="请选择审核状态">
                <a-select-option :value="0"> 待审批 </a-select-option>
                <a-select-option :value="1"> 审批通过 </a-select-option>
                <a-select-option :value="2"> 审批不通过 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24"
                 :sm="48"
                 style="display: flex">
            <a-form-item>
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 12px"
                        @click="approval()"
                        v-action:approva>审批</a-button>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()"
                        v-action:delete>删除</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table ref="table"
             rowKey="id"
             size="middle"
             bordered
             :scroll="{ x: 2100 }"
             :columns="columns"
             :loading="dataListLoading"
             :dataSource="list"
             :pagination="pagination"
             :rowSelection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             @change="pageChange">
      <span slot="reconnaissanceStatus"
            slot-scope="text, record">
        <a-tag v-if="record.reconnaissanceStatus === 0"
               color="rgb(255, 99, 71)">未开始</a-tag>
        <a-tag v-if="record.reconnaissanceStatus === 1"
               color="#f98303">勘测进行中</a-tag>
        <a-tag v-if="record.reconnaissanceStatus === 2"
               color="rgb(50, 205, 50)">勘测已完成</a-tag>
      </span>
      <span slot="approveStatus"
            slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0"
               color="rgb(255, 99, 71)">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1"
               color="rgb(50, 205, 50)">审批通过 </a-tag>
        <a-tag v-if="record.approveStatus === 2"
               color="rgb(255, 99, 71">审批不通过</a-tag>
      </span>

      <div slot="action"
           slot-scope="text, record"
           style="width: 90px; display: flex; justify-content: space-between">
        <span v-if="record.executeUserId == climbId">
          <a-button size="small"
                    type="primary"
                    style="font-size: 12px; margin-left: 15px"
                    v-if="record.reconnaissanceStatus == 0"
                    @click="startck(record.id, 1, record)">
            开始
          </a-button>

          <a-button size="small"
                    type="primary"
                    style="font-size: 12px; margin-left: 15px"
                    v-if="record.reconnaissanceStatus == 1"
                    @click="addOrUpdateHandle(record.id, '提交')">
            提交
          </a-button>
          <a-button size="small"
                    type="primary"
                    style="font-size: 12px; margin-left: 15px"
                    v-if="record.reconnaissanceStatus == 2"
                    disabled>
            完成
          </a-button>
        </span>

        <a-button size="small"
                  type="primary"
                  style="font-size: 12px; margin-left: 15px"
                  @click="addOrUpdateHandle(record.id, '查看')">
          查看
        </a-button>

        <a-button size="small"
                  type="danger"
                  v-if="record.closeOrOpen == 0"
                  @click="closureck(record.id)"
                  style="font-size: 12px; margin-left: 15px"
                  v-action:closure>
          关闭
        </a-button>

        <a-button size="small"
                  v-if="record.closeOrOpen == 1"
                  @click="closureck(record.id)"
                  style="font-size: 12px; background-color: rgb(246, 255, 237); color: green; margin-left: 15px"
                  v-action:turn>
          开启
        </a-button>
      </div>
    </a-table>
    <!-- 关闭 -->
    <a-modal title="关闭"
             style="top: 20px"
             :width="800"
             :visible="closure"
             :confirm-loading="confirmLoading"
             @cancel="handleCancel"
             @ok="Closeok">
      <a-form-item label="关闭状态">
        <a-radio-group v-model="engineeringProjectReconnaissance.closeOrOpen">
          <a-radio :value="1">关闭</a-radio>
          <a-radio :value="0">开启</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-modal>
    <!-- 审批 -->
    <a-modal :title="this.titih"
             style="top: 20px"
             :width="800"
             :visible="addOrUpdateVisible"
             v-model="addOrUpdateVisible">
      <a-form-model class="tenant-form"
                    :model="engineeringProjectEstab"
                    ref="engineeringProjectEstab"
                    :rules="rules">
        <a-form-model-item label="项目编号"
                           prop="establishmentNo"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <a-input disabled
                   v-model="engineeringProjectEstab.establishmentNo"
                   placeholder="系统自动按规则生成" />
        </a-form-model-item>
        <a-form-model-item label="项目名称"
                           prop="establishmentName"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.establishmentName"
                   disabled />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           label="审核状态"
                           prop="approveStatus">
          <a-radio-group v-model="engineeringProjectEstab.approveStatus"
                         @change="onChangejt">
            <!-- <a-radio :value="0">待审批</a-radio> -->
            <a-radio :value="1">审批通过</a-radio>
            <a-radio :value="2">审批不通过</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审批意见"
                           prop="approvalOpinion"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectEstab.approvalOpinion" />
        </a-form-model-item>
        <a-form-model-item label="负责人"
                           prop="userId"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           v-if="engineeringProjectEstab.approveStatus == 1">
          <a-select placeholder="选择一个负责人"
                    v-model="engineeringProjectEstab.userId">
            <a-select-option v-for="item in userlist"
                             :key="item.key.principalId"
                             :value="item.key.principalId">
              {{ item.key.principal }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <div v-if="engineeringProjectEstab.approveStatus == 1">
          <a-form-model-item :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                             label="计划开始时间"
                             prop="startValue">
            <a-date-picker v-model="engineeringProjectEstab.startValue"
                           :disabled-date="disabledStartDate"
                           show-time
                           @change="onChange"
                           format="YYYY-MM-DD HH:mm:ss"
                           @openChange="handleStartOpenChange" />
          </a-form-model-item>
          <a-form-model-item :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                             label="计划结束时间"
                             prop="endValue">
            <a-date-picker v-model="engineeringProjectEstab.endValue"
                           :disabled-date="disabledEndDate"
                           show-time
                           format="YYYY-MM-DD HH:mm:ss"
                           :open="endOpen"
                           @change="onChanget"
                           @openChange="handleEndOpenChange" />
          </a-form-model-item>
        </div>
        <a-form-model-item :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           label="备注"
                           prop="remark">
          <a-textarea v-model="engineeringProjectEstab.remark"
                      :rows="4"
                      :disabled="disabled"
                      style="width: 690px" />
        </a-form-model-item>
        <a-form-model-item label="附件上传"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <div class="fileDiv">
            <ul>
              <li class="fileLi"
                  v-for="item in engineeringProjectEstab.fileNames"
                  :key="item.url">
                <div class="uploadDiv"
                     @click="uploadFile(item)">
                  <a-icon type="file-done"
                          style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button :disabled="isUpdate"
                  type="primary"
                  @click="handlesOk">确定</a-button>
      </template>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal :title="this.titih"
             :visible="visibles"
             style="top: 20px"
             :width="800"
             :destroyOnClose="true"
             :confirm-loading="confirmLoading"
             @cancel="handleCancel">
      <a-row>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 项目编码：</span>{{ Details.establishmentNo }}</p>
        </a-col>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 项目名称：</span>{{ Details.establishmentName }}</p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 联系方式：</span>{{ Details.phone }}</p>
        </a-col>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 地址：</span>{{ Details.address }}</p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 备注：</span>{{ Details.remark }}</p>
        </a-col>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 执行人：</span>{{ Details.executeUserName }}</p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <p>
            <span style="font-size: 16px"> 勘探状态：</span>
            <span>
              <a-tag v-if="Details.reconnaissanceStatus === 0"
                     color="rgb(255, 99, 71)">未开始</a-tag>
              <a-tag v-if="Details.reconnaissanceStatus === 1"
                     color="#f98303">勘测进行中</a-tag>
              <a-tag v-if="Details.reconnaissanceStatus === 2"
                     color="rgb(50, 205, 50)">勘测已完成</a-tag>
              <!-- <a-tag v-if="Details.reconnaissanceStatus === 0" color="#F0F8FF">未开始</a-tag>
              <a-tag v-if="Details.reconnaissanceStatus === 1" color="#F0E68C">勘测进行中</a-tag>
              <a-tag v-if="Details.reconnaissanceStatus === 2" color="#00FF7F">勘测已完成</a-tag> -->
            </span>
          </p>
        </a-col>
        <a-col :span="12">
          <p>
            <span style="font-size: 16px"> 审核状态：</span>
            <span>
              <a-tag v-if="Details.approveStatus === 0"
                     color="rgb(255, 99, 71)">待审批</a-tag>
              <a-tag v-if="Details.approveStatus === 1"
                     color="rgb(50, 205, 50)">审批通过 </a-tag>
              <a-tag v-if="Details.approveStatus === 2"
                     color="rgb(255, 99, 71)">审批不通过</a-tag>
              <!-- <a-tag v-if="Details.approveStatus === 0" color="#F0F8FF">待审批</a-tag>
              <a-tag v-if="Details.approveStatus === 1" color="#00FF7F">审批通过</a-tag>
              <a-tag v-if="Details.approveStatus === 2" color="#FF6600">审批不通过</a-tag> -->
            </span>
          </p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 计划开始时间：</span>{{ Details.startTime }}</p>
        </a-col>
        <a-col :span="12">
          <p><span style="font-size: 16px"> 计划完成时间：</span>{{ Details.endTime }}</p>
        </a-col>
      </a-row>
      <a-form-model class="log-form"
                    :model="engineeringProjectEstab"
                    :label-col="{ span: 2 }"
                    :wrapper-col="{ span: 22 }">
        <a-form-model-item label="文字描述"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <a-textarea v-model="engineeringProjectEstab.describe"
                      :rows="4"
                      :disabled="!Toview"
                      style="width: 690px" />
        </a-form-model-item>
        <a-form-model-item label="附件上传"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <a-upload-dragger name="file"
                            :multiple="true"
                            :customRequest="customReques"
                            :showUploadList="false"
                            v-show="Toview">
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              文件拖拽此处或
              <a>点击上传</a>
            </p>
          </a-upload-dragger>
          <div class="fileDiv">
            <ul>
              <li class="fileLi"
                  v-for="item in engineeringProjectEstab.fileNames"
                  :key="item.url">
                <div class="uploadDiv"
                     @click="uploadFile(item)">
                  <a-icon type="file-done"
                          style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <a-icon v-if="titih == '提交'"
                        type="delete"
                        style="float: right; cursor: pointer; margin-top: -25px"
                        @click="deleteFile(item.url)" />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
      <template #footer>
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary"
                  @click="handlelOk(0)"
                  :disabled="disabled"
                  v-show="Toview">完成</a-button>
        <a-button type="primary"
                  @click="handlelOk(1)"
                  :disabled="disabled"
                  v-show="Toview">保存</a-button>
      </template>
    </a-modal>
  </a-card>
</template>
<script>
import mixinViewModule from '@/mixin/common'
import icons from '@/components/IconSelector/icons'

export default {
  name: 'PointCheck',
  mixins: [mixinViewModule],
  data () {
    return {
      queryUrl: '/pipe-network/engineering_project_reconnaissances/page', // 列表请求数据接口
      queryOneUrl: '/pipe-network/engineering_project_reconnaissances', // 查询单条地址
      addOrUpdateUrl: '/pipe-network/engineering_project_reconnaissances', // 新增或更新数据url
      deleteUrl: '/pipe-network/engineering_project_reconnaissances', // 删除数据url
      addOrUpdateVisible: false, // 新增修改是否可见
      isUpdate: false,
      closure: false, // 关闭
      confirmLoading: false,
      disabled: false,
      visibles: false,
      apprOpinion: true,
      endOpen: false,
      Details: {},
      userlist: [],
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      engineeringProjectReconnaissance: {
        id: 0,
        closeOrOpen: 0
        // 关闭的字段填写这里
      },
      engineeringProjectEstab: {
        id: 0,
        remark: '',
        describe: '',
        endTime: '',
        startTime: '',
        fileNames: [],
        approveStatus: 0,
        establishmentNo: '',
        establishmentName: '',
        reconnaissanceStatus: '',
        userId: '',
        approvalOpinion: '',
        startValue: null,
        endValue: null
      },
      rules: {
        establishmentName: [{ required: true, message: '请输入项目名称', trigger: 'change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'change' }],
        establishmentType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        establishmentUserName: [{ required: true, message: '请输入负责人', trigger: 'blchangeur' }],
        approveStatus: [{ required: true, message: '请选择审批状态', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
        reconnaissanceStatus: [{ required: true, message: '请选择勘探状态', trigger: 'change' }],
        userId: [{ required: true, message: '请选择项目负责人', trigger: 'change' }],
        approvalOpinion: [{ required: true, message: '请输入审批意见', trigger: 'change' }]
      },
      selectedRowKeys: [],
      list: [],
      titih: '审批',
      climbId: null,
      Toview: false,
      query: {
        establishmentNo: '',
        establishmentName: '',
        planStartTime: '',
        planEndTime: '',
        reconnaissanceStatus: '',
        approveStatus: '',
        endTime: '',
        endTime: '',
        stateType: 1
      },
      columns: [
        {
          title: '编号',
          dataIndex: 'establishmentNo'
        },
        {
          title: '项目名称',
          dataIndex: 'establishmentName',
          ellipsis: true
        },
        {
          title: '计划开始时间',
          dataIndex: 'startTime'
        },
        {
          title: '计划完成时间',
          dataIndex: 'endTime'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '实际完成时间',
          dataIndex: 'realityEndTime'
        },
        {
          title: '执行人',
          dataIndex: 'executeUserName'
        },
        {
          title: '勘察状态',
          dataIndex: 'reconnaissanceStatus',
          scopedSlots: { customRender: 'reconnaissanceStatus' }
        },
        {
          title: '审核状态',
          dataIndex: 'approveStatus',
          scopedSlots: { customRender: 'approveStatus' }
        },
        {
          title: '审核时间',
          dataIndex: 'approveTime'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true
        },
        {
          title: '审批意见',
          dataIndex: 'approvalOpinion'
        },
        {
          title: '操作',
          align: 'center',
          key: 'operation',
          fixed: 'right',
          width: 200,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      createTaskFrom: {
        name: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 4 },
      wrapperCol: { span: 18 }
    }
  },
  created () {
    this.queryList()
    this.Responsibleinterface()
    this.currentUser()
    this.resetList()
  },
  methods: {
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          // console.log(JSON.stringify(data))
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            this.selectedRows = []
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    currentUser () {
      this.climbId = this.$store.getters.userInfo.id
      console.log(this.climbId)
    },
    token () {
      return this.$store.getters.token
    },
    // 时间
    disabledStartDate (startValue) {
      const endValue = this.engineeringProjectEstab.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate (endValue) {
      const startValue = this.engineeringProjectEstab.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange (open) {
      this.endOpen = open
    },
    // 负责人下拉框
    Responsibleinterface () {
      this.$http.get('/pipe-network/engineering_project_establishments/principals').then(({ data }) => {
        const list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.real_name,
            key: item,
            name: item.real_name
          })
        })
        this.userlist = list
      })
    },
    // 字
    // 开启
    startck (id, i, recordt) {
      this.engineeringProjectEstab.id = id
      this.engineeringProjectEstab.reconnaissanceStatus = i
      this.engineeringProjectEstab = {
        id: id,
        remark: recordt.remark,
        describe: recordt.describe,
        endTime: recordt.endTime,
        startTime: recordt.startTime,
        fileNames: recordt.fileNames,
        approveStatus: recordt.approveStatus,
        establishmentNo: recordt.establishmentNo,
        establishmentName: recordt.establishmentName,
        reconnaissanceStatus: i
      }
      this.$http
        .put('/pipe-network/engineering_project_reconnaissances', {
          id: this.engineeringProjectEstab.id,
          ...this.engineeringProjectEstab
        })
        .then((res) => {
          console.log(res.data)
          if (res.message == '操作成功') {
            this.$message.success(res.message)
            this.queryList()
          } else {
            this.$message.success('操作失败')
          }
        })
    },
    // 查看详情对话框
    handlelOk (i) {
      if (i == 0) {
        this.engineeringProjectEstab.reconnaissanceStatus = 2
      } else {
        this.engineeringProjectEstab.reconnaissanceStatus = 1
      }
      this.$http
        .put('/pipe-network/engineering_project_reconnaissances', {
          id: this.engineeringProjectEstab.id,
          ...this.engineeringProjectEstab
        })
        .then((res) => {
          if (res.code == 0) {
            this.visibles = false
            this.queryList()
            return this.$message.success(res.message)
          } else {
            this.visibles = false
            return this.$message.warn(res.message)
          }
        })
    },

    // 根据id 修改
    addOrUpdateHandle (id, i) {
      this.titih = i
      if (this.titih == '查看') {
        this.Toview = false
      } else {
        this.Toview = true
      }
      this.isUpdate = true
      this.visibles = true
      this.currentId = id
      // this.addOrUpdateForm.resetFields()
      this.RightData = []
      if (id) {
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.Details = data
            this.engineeringProjectEstab = {
              id: data.id,
              remark: data.remark,
              describe: data.describe,
              fileNames: data.fileNames,
              approveStatus: data.approveStatus,
              establishmentNo: data.establishmentNo,
              establishmentName: data.establishmentName,
              reconnaissanceStatus: data.reconnaissanceStatus,
              approvalOpinion: data.approvalOpinion
            }
            // this.engineeringProjectEstab.fileNames = data.fileNames
            // this.engineeringProjectEstab.id = data.id
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => { })
      }
    },
    // 关闭
    closureck (id) {
      this.closure = true
      this.engineeringProjectReconnaissance.id = id
      this.currentId = id
      this.$http
        .get(`${this.queryOneUrl}/${this.currentId}`)
        .then(({ data }) => {
          this.engineeringProjectReconnaissance.closeOrOpen = data.closeOrOpen
        })
        .catch(() => { })
    },
    Closeok () {
      this.$http
        .put(`/pipe-network/engineering_project_reconnaissances/close-open`, {
          ...this.engineeringProjectReconnaissance
        })
        .then((res) => {
          console.log(res.data)
          if (res.message == '操作成功') {
            this.$message.success(res.message)
            this.queryList()
          } else {
            this.$message.success('操作失败')
          }
        })
      this.closure = false
    },
    handleCancel () {
      this.visibles = false
      this.addOrUpdateVisible = false
      this.closure = false
      this.$refs.engineeringProjectEstab.resetFields()
    },
    // 审批
    approval () {
      this.titih = '审批'
      this.isUpdate = false
      if (this.selectedRows.length == 1) {
        console.log(this.selectedRows[0])
        this.currentId = this.selectedRows[0]

        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.engineeringProjectEstab = {
              id: data.id,
              remark: data.remark,
              describe: data.describe,
              fileNames: data.fileNames,
              approveStatus: data.approveStatus,
              establishmentNo: data.establishmentNo,
              establishmentName: data.establishmentName,
              reconnaissanceStatus: data.reconnaissanceStatus,
              approvalOpinion: data.approvalOpinion
            }
            if (data.closeOrOpen == 1) {
              this.disabled = true
              this.isUpdate = true
              this.addOrUpdateVisible = false
              return this.$message.warn('当前项目已关闭！')
            } else {
              this.disabled = false
              this.isUpdate = false
              this.addOrUpdateVisible = true
            }
          })
          .catch(() => { })
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要审批的事件')
      } else {
        return this.$message.warn('只能选择一条要审批的事件')
      }
    },
    // 确定审批
    handlesOk () {
      this.$refs.engineeringProjectEstab.validate((valid) => {
        if (valid) {
          this.$http
            .put('/pipe-network/engineering_project_reconnaissances', {
              id: this.engineeringProjectEstab.id,
              ...this.engineeringProjectEstab
            })
            .then((res) => {
              if (res.code == 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              } else {
                this.addOrUpdateVisible = false
                return this.$message.warn(res.message)
              }
            })
          this.$refs.engineeringProjectEstab.resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onChange (date, dateString) {
      this.engineeringProjectEstab.startTime = dateString
    },
    onChanget (date, dateString) {
      console.log(dateString, '时间')
      this.engineeringProjectEstab.endTime = dateString
    },
    onChangejt (value) {
      if (value.target.value == 2) {
        this.apprOpinion = false
      } else {
        this.apprOpinion = true
      }
    },
    onOk (value) {
      console.log('onOk: ', value)
    },
    // 上传
    customReques (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            const obj = {
              url: response.data.url,
              name: response.data.fileName
            }
            this.engineeringProjectEstab.fileNames.push(obj)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile (item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile (url) {
      const index = this.engineeringProjectEstab.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.engineeringProjectEstab.fileNames.splice(index, 1)
    }
  },

  // 确认审批
  approvalHandle () {
    console.log('555555')
    this.$http.put(`${this.addOrUpdateUrl}`, { ...this.addOrUpdateForm }).then((res) => {
      if (res.message == '操作成功') {
        this.$message.success(res.message)
        this.visible = false
        this.queryList()
      } else {
        this.$message.success('操作失败')
      }
    })
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.a-card {
  width: 100%;
  height: 100%;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
